import React, { useState, useContext, useRef } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import { userInfo } from 'models/source';
import { emailValidator } from 'utils/formValidators';
import { StatusContext } from 'contexts/statusContext';
import {
  Button, TextInput, Checkbox, PhoneInput, Form,
} from 'components/common';
import Modal from 'components/modals/Modal';

const ContactWithCustomerModal = ({ t, visible, setVisible }) => {
  const { setErrorState } = useContext(StatusContext);

  const [onResponse, setOnResponse] = useState(false);

  const [fullName, setFullName] = useState('');
  const [kvkk, setKvkk] = useState(false);
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [isBuyer, setIsBuyer] = useState(false);
  const [isSeller, setIsSeller] = useState(false);

  const [formRef, setFormRef] = useState(useRef());

  const sendRequest = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await userInfo({
          fullName,
          kvkk,
          email,
          phone,
          isBuyer,
          isSeller,
        });
        setVisible(false);
        formRef.setFieldsValue({
          fullName: '',
          kvkk: false,
          email: '',
          phone: '',
          buyer: '',
          seller: '',
        });
        setFullName('');
        setIsSeller('');
        setIsBuyer('');
        setEmail('');
        setPhone('+90');
        setKvkk(false);
        setErrorState({
          title: t('successful'),
          text: 'Talebiniz başarılı bir şekilde bize ulaşmıştır.',
          buttonText: t('close'),
          type: 'success',
          onClickButton: () => setErrorState({}),
        });
      } catch (error) {
        console.log('ContacWithCustomerModalRequestErr', error);
        setTimeout(() => {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }, 500);
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <Form
        layout="vertical"
        onFinish={sendRequest}
        formRef={(ref) => setFormRef(ref)}
      >
        <div className="modal-content modal-transparent">
          <div className="modal-body p-0">
            <div className="im-box im-box--white im-box--border-radius im-box--padding-sm-15">
              <div className="row">
                <div className="col">
                  <div className="fs-20 fw-900 text-center">
                    SİZİ ARAYALIM
                  </div>
                  <p className="fs-12 text-gray3 mt-3 text-center">
                    Bilgilerinizi girin, müşteri
                    temsilcimiz sizinle hemen iletişime
                    geçsin.
                  </p>
                  <div className="separator separator--horizontal mt-4 mb-4" />
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-15">
                  <div className="row justify-content-center mb-3 fw-900">
                    <div className="mr-3">
                      <Checkbox
                        name="buyer"
                        value={isBuyer}
                        onChange={({ value }) => {
                          setIsBuyer(value);
                        }}
                        text="Alıcıyım"
                        required={!isSeller}
                      />
                    </div>
                    <div className="ml-3">
                      <Checkbox
                        name="seller"
                        value={isSeller}
                        onChange={({ value }) => {
                          setIsSeller(value);
                        }}
                        text="Satıcıyım"
                        required={!isBuyer}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      <div className="row mb-3">
                        <div className="im-list__value">
                          Adınız Soyadınız
                        </div>
                      </div>
                      <TextInput
                        name="fullName"
                        placeholder={t('fullName')}
                        value={fullName}
                        onChange={({ value }) => setFullName(value)}
                        hideLabel
                        required
                      />
                    </div>
                    <div className="col">
                      <div className="row mb-3">
                        <div className="im-list__value">
                          {t('phoneNumber')}
                        </div>
                      </div>
                      <PhoneInput
                        name="phone"
                        value={phone}
                        onChange={({ value }) => setPhone(value)}
                        hideLabel
                        required
                        mobileNumber
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-5">
                <div className="col-15">
                  <div className="row mb-3">
                    <div className=" col im-list__value">
                      E-posta Adresiniz
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <TextInput
                        name="email"
                        type="email"
                        placeholder={t('email')}
                        value={email}
                        onChange={({ value }) => setEmail(value)}
                        validator={emailValidator}
                        hideLabel
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4 mb-4">
                <div className="col">
                  <div className="separator separator--horizontal" />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col col-lg-15">
                  <Checkbox
                    containerClassName="mb-4"
                    name="kvkk"
                    value={kvkk}
                    onChange={({ value }) => setKvkk(value)}
                    text="iyiMakina.com tarafından ileti gönderilmesini, bilgilerimin bu amaçla saklanmasını, kampanya ve tekliflerden yararlanmak için E-Posta, SMS vb. iletileri ve aramaları almayı, gönderime ilişkin hizmet alınan taraflarla paylaşılmasını haklarım saklı kalmak kaydı ile kabul ediyorum."
                    required
                  />
                </div>
              </div>
              <div className="row justify-content-md-center">
                <div className="col col-lg-10">
                  <Button
                    htmlType="submit"
                    className="im-button im-button--primary im-button--fluid im-button--center"
                    label={t('send')}
                    loading={onResponse}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

ContactWithCustomerModal.propTypes = {
  t: PropTypes.func,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
};

export default withTranslation('common')(ContactWithCustomerModal);
